import { Form, Row, Col, Card, Breadcrumb, } from "@deere/ux.uxframe-react";
//import { Fragment } from "react";
import React, {Fragment, useEffect, useState} from 'react';

import { Link } from 'react-router-dom';
import {useOktaAuth} from "@okta/okta-react";

export default function useDocument() {

    //const [isLoading, setIsLoading] = useState(false);
    //setIsLoading(true);

    const {authState} = useOktaAuth();
    if (!authState.isAuthenticated) {
       // await authService.login();
        return;
    }

   /* const {authState} = useOktaAuth();
    if (!authState) {
        return;
    }*/

    return (
        <Fragment>
            <title>Error Documents</title>
            <Card style={{ margin: '2%' }}>
                <div style={{ marginTop: '2%', marginLeft: '2%' }}><Breadcrumb links={[{
                    title: "Home",
                    href: "/Viewlist"
                }, {
                    title: "Error Documents",
                }]} label="breadcrumbs" />

                    <Card.Body>

                        <Card.Title style={{ marginLeft: '1%', fontWeight: "bold" }}>Error Documents</Card.Title>
                        <Row style={{ marginTop: '4%' }}>
                            <Col xs={12} md={7}>

                                <Form.Group as={Row} className="mb-3" style={{ marginLeft: '1%' }}>
                                    <Form.Label>No Inbound Delivery Item Error:</Form.Label>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" style={{ marginLeft: '2.5%' }}>
                                    <Link to="../../No Inbound Error Process Map.xls" target="_blank" download>Process Map</Link>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" style={{ marginLeft: '2.5%' }}>
                                    <Link to="../../Inbound Error.ppt" target="_blank" download>Step-By-Step Screen Shots</Link>
                                </Form.Group>

                            </Col>

                            <Col xs={12} md={7}>
                                <Form.Group as={Row} className="mb-3" style={{ marginLeft: '5%' }}>
                                    <Form.Label>Order Cannot be Delivered Error:</Form.Label>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" style={{ marginLeft: '6.5%' }}>
                                    <Link to="../../Order Cannot be Delivered Error Process Map.xls" target="_blank" download>Process Map</Link>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" style={{ marginLeft: '6.5%' }}>
                                    <Link to="../../Error Resolution for Order Cannot be Delivered.ppt" target="_blank" download>Step-By-Step Screen Shots</Link>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row style={{ marginTop: 40 }}>
                            <Col xs={12} md={7}>
                                <Form.Group as={Row} className="mb-3" style={{ marginLeft: '1%' }}>
                                    <Form.Label>Deficit of SL Unrestricted Error:</Form.Label>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" style={{ marginLeft: '2.5%' }}>
                                    <Link to="../../Deficit of SL Unrestricted Error.xls" target="_blank" download>Process Map</Link>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" style={{ marginLeft: '2.5%' }}>
                                    <Link to="../../Deficit of SL Unrestricted Error.ppt" target="_blank" download>Step-By-Step Screen Shots</Link>
                                </Form.Group>

                            </Col>
                            <Col xs={12} md={7}>
                                <Form.Group as={Row} className="mb-3" style={{ marginLeft: '5%' }}>
                                    <Form.Label>Multi-Unit ASNs Error:</Form.Label>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" style={{ marginLeft: '6.5%' }}>
                                    <Link to="../../Shared ASNs Vendor Error Method.pptx" target="_blank" download>Step-By-Step Screen Shots</Link>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Card.Body></div></Card>
        </Fragment>
    );
}